module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "table-main"
  }, [_vm._m(0), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main-wrap"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "main-item"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("cycleStr")(item)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("CycleTypeText")(item.distribute_type)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.confirm_time ? item.confirm_time : "-- --"))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.confirm_time ? "是" : "否"))]), _vm._v(" "), _c('div', {
      staticClass: "end-func",
      class: {
        red: !item.confirm_time
      },
      on: {
        "click": function($event) {
          _vm.showBill(item)
        }
      }
    }, [_vm._v(_vm._s(item.confirm_time ? '详情' : '结算'))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "z-bill",
    attrs: {
      "title": "结算账单",
      "size": 'large',
      "visible": _vm.billFlag
    },
    on: {
      "update:visible": function($event) {
        _vm.billFlag = $event
      }
    }
  }, [_c('div', {
    staticClass: "bill-table"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v("奖金周期")]), _vm._v(" "), _c('div', [_vm._v("快币类型")]), _vm._v(" "), _c('div', [_vm._v("数量")]), _vm._v(" "), _c('div', [_vm._v("当期汇率")]), _vm._v(" "), _c('div', [_vm._v("金额")])]), _vm._v(" "), _vm._l((_vm.billList), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "item"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("cycleStr")(index == 0 ? item : "")))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.trans_amount + '币'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.currency_rate))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("ticket_curr")(item)))])])
  }), _vm._v(" "), (_vm.bill.periodCurrPersonalSummary && _vm.bill.periodCurrPersonalSummary.confirm_money < 0) ? _c('div', {
    staticClass: "item deviate"
  }, [_c('div', [_vm._v("上期结余")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.bill.periodCurrPersonalSummary)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item deviate"
  }, [_c('div', [_vm._v("合计")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("bonus")(_vm.bill.currPersonalSummary)))])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.confirmTime),
      expression: "!confirmTime"
    }],
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.billFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.bill_loading
    },
    on: {
      "click": _vm.bill_confirm
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-head"
  }, [_c('div', [_vm._v("奖金周期")]), _vm._v(" "), _c('div', [_vm._v("奖金周期类型")]), _vm._v(" "), _c('div', [_vm._v("结算单生成日期")]), _vm._v(" "), _c('div', [_vm._v("结算单确认日期")]), _vm._v(" "), _c('div', [_vm._v("是否已确认")]), _vm._v(" "), _c('div', [_vm._v("详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-135a7813!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/accountsTable.vue
// module id = 694
// module chunks = 1